import { BackendClient, type BackendTypes } from '@tf/api';

export const monitoringSearchDetailsQuery = async (
	params: BackendTypes.MonitoringSearchDetailsParams
): Promise<BackendTypes.MonitoringSearchDetailsData> => {
	const res = await BackendClient.getInstance().monitoringSearchDetails(params);
	return res.json();
};
